/**
 * Value Object AccountNumber - représente un numéro de compte
 *
 * Règles métier:
 * - Doit contenir exactement 12 chiffres
 * - Immutable
 */

import { isValidAccountNumber } from '../../shared/utils/validators';

export class AccountNumber {
  private constructor(private readonly _value: string) {
    if (!isValidAccountNumber(_value)) {
      throw new Error(`Invalid account number format: ${_value}. Must be 10-20 digits.`);
    }
    Object.freeze(this);
  }

  /**
   * Crée une instance AccountNumber
   */
  static create(value: string): AccountNumber {
    return new AccountNumber(value);
  }

  get value(): string {
    return this._value;
  }

  /**
   * Compare deux AccountNumber
   */
  equals(other: AccountNumber): boolean {
    return this._value === other._value;
  }

  /**
   * Formate le numéro de compte pour affichage
   * @example "15005000000000001" -> "1500 5000 0000 0000 1"
   */
  format(): string {
    return this._value.replace(/(.{4})/g, '$1 ').trim();
  }

  /**
   * Sérialise pour persistence
   */
  toJSON(): string {
    return this._value;
  }

  /**
   * Désérialise depuis persistence
   */
  static fromJSON(value: string): AccountNumber {
    return new AccountNumber(value);
  }

  /**
   * Représentation textuelle
   */
  toString(): string {
    return this._value;
  }
}
